import { createAction, props } from '@ngrx/store';
import { Vehicle } from '../../maintenance/models/vehicle.interface';

export const loadVehicles = createAction('[Vehicles/API] Load Vehicles');

export const loadedVehicles = createAction('[Vehicles/API] Loaded Vehicles Success', props<{ vehicles: Vehicle[] }>());
